/**
 * Export data as a CSV file download.
 * @param {string} filename - Name of the downloaded file (without .csv extension)
 * @param {Array<{label: string, key: string, format?: (row: any) => string}>} columns - Column definitions
 * @param {Array<object>} data - Array of row objects
 */
export function exportCsv(filename, columns, data) {
  // Handle fallback signature: exportCsv(data, filename)
  if (Array.isArray(filename) && typeof columns === 'string') {
    const rawData = filename;
    const fname = columns.replace(/\.csv$/, '');
    if (rawData.length === 0) return;
    const keys = Object.keys(rawData[0]);
    const cols = keys.map((k) => ({ label: k, key: k }));
    return exportCsv(fname, cols, rawData);
  }
  if (!Array.isArray(columns) || !Array.isArray(data)) return;
  const header = columns.map((c) => c.label).join(',');
  const rows = data.map((row) =>
    columns
      .map((c) => {
        const val = c.format ? c.format(row) : (row[c.key] ?? '');
        const str = String(val);
        return `"${str.replace(/"/g, '""')}"`;
      })
      .join(',')
  );
  const csv = [header, ...rows].join('\n');
  // Prepend a UTF-8 BOM so Excel (which otherwise assumes the system locale,
  // e.g. Windows-1252) decodes multi-byte characters like the Rupee sign ₹
  // correctly instead of showing mojibake (â‚¹).
  const blob = new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
